<!-- Main-error-wrapper -->
<div class="main-error-wrapper page page-h">
    <img src="../../assets/img/media/404.png" class="error-page" alt="error">
    <h2>Oopps. The page you were looking for doesn't exist.</h2>
    <h6>You may have mistyped the address or the page may have moved or you don't have permission to view this page</h6>
</div>
<!-- /Main-error-wrapper -->